// node modules
import React from 'react';
import { useSelector } from 'react-redux';

// app modules: components
import InAppOfferPrice from './InAppOfferPrice';
import DefaultOfferPrice from './DefaultOfferPrice';

function OfferPrice(props) {
  const buildPlatform = useSelector(state => state.config.platform);

  if (buildPlatform === 'app') {
    return <InAppOfferPrice {...props} />;
  }
  // Web users users get Paddle prices.
  return <DefaultOfferPrice {...props} />;
}

export default OfferPrice;
